import { put, select } from 'redux-saga/effects';
import { ErrorAction } from '@sofology/sofologycomponents';
import { Action } from 'redux';
import { ACTION_CREATOR_NAME, analyticsHelper } from 'helpers';
import { PaymentActionTypes, PaymentActions } from 'store/payment';
import { BasketErrorModel } from 'models/Errors';
import { AppState } from 'store/root.types';

const CARD_ERROR_MESSAGE = "Your payment failed. Please check your payment details and try again. If the problem persists, please try a different payment card or method, or call us on 0800 140 40 40 and we'll be happy to help.";

export interface CardPaymentRejectAction extends Action<PaymentActionTypes.CARD_PAYMENT_REJECT> {
}

export interface CardPaymentRejectSuccessAction extends ErrorAction<PaymentActionTypes.CARD_PAYMENT_REJECT_SUCCESS> {
}

export const cardPaymentReject: () => CardPaymentRejectAction = () => ({
    type: PaymentActionTypes.CARD_PAYMENT_REJECT
});
cardPaymentReject[ACTION_CREATOR_NAME] = 'cardPaymentReject';

export type CardPaymentRejectFunc = (...args: Parameters<typeof cardPaymentReject>) => void;

export function* cardPaymentRejectSaga() {
    yield put<PaymentActions>({
        type: PaymentActionTypes.CARD_PAYMENT_REJECT_SUCCESS,
        error: new BasketErrorModel(CARD_ERROR_MESSAGE, undefined, 'cardPaymentRejectSaga')
    });

    yield sendAnalytics();
}

function* sendAnalytics(): Generator<any, void, any> {
    yield analyticsHelper.withLoggingGenerator(function* () {
        const state: AppState = yield select();
        analyticsHelper.sendToGoogleMessageAboutPaymentError(state.basketState.basket, state.paymentState.paymentDetails);
    }, 'cardPaymentRejectSaga');
}